import { TFunction } from "i18next";
import { DeepMap } from "react-hook-form";
import { ErrorOption } from "react-hook-form/dist/types/errors";
import { FieldName } from "react-hook-form/dist/types/fields";

interface IToggleFileSizeError {
  t: TFunction;
  setError: (name: FieldName<any>, error: ErrorOption) => void;
  errors: DeepMap<any, any>;
}

export const toggleFileSizeError =
  ({ t, errors, setError }: IToggleFileSizeError) =>
  (hide: boolean, name: string) => {
    errors.DataConsentId && setError("DataConsentId", {});
    hide
      ? setError(name, {})
      : setError(name, {
          message: t("validation.fileSIzeUp5Mb"),
          type: "sizeError",
        });
  };
